module.exports = __webpack_public_path__ + "static/media/1_group.ee6d7e44.jpg";